// eslint-disable-next-line import/prefer-default-export
export const Routes = {
  HOME: '/',
  VALIDATE_TOKEN: '/validate/:token/dest/:dest',
  LOGIN: '/login',
  SIGN_IN: '/signin',
  SIGN_UP: '/signup',
  SIGN_UP_OLACLICK_REFERRALS_MX: '/referral/olaclick/mx',
  SIGN_UP_OLACLICK_REFERRALS: '/referral/olaclick/:country',
  SIGN_UP_ORDER_EAT_REFERRALS: '/referral/ordereat/mx',
  SIGN_UP_GENERIC_REFERRALS: '/referral',
  SIGN_UP_DYNAMIC_REFERRALS: '/referral/:language?/:mainMerchantId/:country',
  AUTH_QR: '/auth/scanqr',
  AUTH_MFA: '/auth/mfa',
  LOGIN_MFA: '/login/mfa',
  FORGOT_PASS: '/forgot/password',
  RESET_PASS: '/reset/password',
  UNAUTHORIZED: '/unauthorized',
  FORBIDDEN: '/forbidden',
  DASHBOARD: '/home',
  CASH_IN: '/cashin',
  CASH_IN_CREATE: '/cashin/request',
  RECURRING_PAYMENTS_IN_CREATE: '/recurringPayment/request',
  UPCOMING_PAYMENTS: '/upcoming-payments',
  CASH_OUT: '/cashout',
  CASH_OUT_CREATE: '/cashout/request',
  NOTES: '/notes',
  NOTE_CREATE: '/notes/create',
  NOTE_DETAILS: '/notes/details/:idNote',
  REFUNDS: '/refunds',
  REFUNDS_DETAILS: '/refunds/:idRefund',
  BALANCE_REPORT: '/balance/report',
  BALANCE_REPORT_WALLET: '/balance/report/wallet',
  SUBMERCHANT_BALANCE: '/balance/submerchant',
  SUBMERCHANT_BALANCE_INTERNAL: '/balance/submerchant/internal/:idMerchant',
  SUBMERCHANT_BALANCE_DETAIL: '/balance/submerchant/:idSubMerchant',
  WALLET_TRANFER: '/wallet/tranfer',
  TRANSACTION_DETAILS_IN: '/cashin/:idTransaction',
  TRANSACTION_DETAILS_OUT: '/cashout/:idTransaction',
  TRANSACTION_DETAILS_ALL_IN: '/transactions/cashin/:idTransaction',
  TRANSACTION_DETAILS_ALL_OUT: '/transactions/cashout/:idTransaction',
  SETTLEMENTS: '/settlements',
  SETTLEMENT_DETAILS: '/settlements/:idSettlement',
  CHARGEBACKS: '/chargebacks',
  CHARGEBACKS_DETAILS_ALL_IN: '/chargebacks/cashin/:idTransaction',
  CLIENTS: '/clients',
  BENEFICIARIES: '/beneficiaries',
  BENEFICIARY_DETAILS: '/beneficiaries/:idBeneficiary',
  CLIENT_DETAILS: '/clients/:idClient',
  MESSAGES: '/messages',
  PAYMENT_METHODS: '/paymentmethods',
  SETTINGS: '/settings/:tabId(company|financial|contacts|integration|mailGroups|accessControlIp|configuration)',
  MERCHANTS: '/merchants',
  PSP_MERCHANTS: '/psp-merchants',
  MERCHANT_SETTINGS: '/merchants/settings/:idMerchant/:tabId(balance|company|financial|contacts|integration|mailGroups|accessControlIp|configuration)',
  SIGN_UP_REQUESTS: '/signup/requests',
  SUPPORT: '/support',
  REFERRED_MERCHANTS: '/referred',
  SUPPORT_CLOSE_TICKET: '/support/close/ticket/:idTicket',
  ACCOUNTS: '/accounts',
  ACCOUNT_EDIT: '/accounts/edit/:idUser',
  ACCOUNT_CREATE_MERCHANT: '/accounts/merchant/create',
  ACCOUNT_CREATE_INTERNAL: '/accounts/internal/create',
  ACCOUNT_EDIT_MERCHANT: '/accounts/edit/merchant/:idUser',
  ACCOUNT_EDIT_INTERNAL: '/accounts/edit/internal/:idUser',
  ACCOUNT_PRESETS: '/accounts/presets',
  NOTIFICATIONS: '/notifications',
  BATCH_CREATION: '/batch',
  BATCH_CASHOUTS: '/batch/cashouts',
  BATCH_CASHOUTS_UPLOAD: '/batch/cashouts/upload',
  TRANSFER: '/exchange',
  TRANSFER_CREATE: '/exchange/request',
  COMMERCIAL_RELATIONSHIP: '/commercialRelationship',
  COMMERCIAL_RELATIONSHIP_CREATE: '/commercialRelationship/create',
  TOP_UPS: '/topUps',
  TOP_UP_DETAILS: '/topUps/:idTopUp',
  FAQS: '/faqs',
  FAQ_DEPOSIT: '/faqs/deposits',
  FAQ_WITHDRAWALS: '/faqs/withdrawals',
  FAQ_REFUNDS: '/faqs/refunds',
  FAQ_CHARGEBACKS: '/faqs/chargebacks',
  FAQ_SETTLEMENTS: '/faqs/settlements',
  FAQ_PAYMENT_METHODS: '/faqs/paymentsmethods',
  FAQ_SETTINGS: '/faqs/settings',
  FAQ_SUPPORT: '/faqs/support',
  RECURRING_PAYMENTS: '/recurringpayments',
  ONKEYVERIFY: '/onkeyverify',
  KYC: '/kyctool',
  ROLLING_RESERVE: '/rollingreserve/:idMerchant',
  PAYMENT_ORDERS: '/paymentorders',
  PAYMENT_ORDERS_BATCHES: '/payment-orders-batches',
  PAYMENT_ORDERS_BATCHES_DETAILS: '/payment-orders-batches/:batchId',

};
